import { computed, defineComponent, reactive } from 'vue';
import Banner from '@/components/Banner.vue';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { UserExamService } from '@/services/userExam.service';
import { ContestPlatformVals, SHOW_BRAND } from '@/utils';
import { UserService } from '@/services/user.service';
import { useRoute, useRouter } from 'vue-router';
import HetaoDefaultAvatar from '@/assets/image/home/contest/default-avatar.png';
import { value2label, CARD_TYPE, SEX, GRADE, CERTIFICATE_GET_METHODS, formatDateToSecond, formatTime } from '@/utils';
import UserCertificate from './components/UserCertificate.vue';
import { environment } from '@/utils/environment';
export default defineComponent({
  name: 'UserItemDetail',
  components: {
    Banner: Banner,
    UserCertificate: UserCertificate
  },
  setup: function () {
    declareProviders([UserExamService]);
    var userExamService = useService(UserExamService);
    var userService = useService(UserService);
    var router = useRouter();
    var route = useRoute();
    var id = +route.params.id;
    userExamService.setUserExamId(id);
    userExamService.getUserExamDetail();
    var userExam = computed(function () {
      return userExamService.userExam;
    });
    var hideGetCertification = computed(function () {
      return environment === 'production' ? userExamService.userExam.contestInfoId === 797 : userExamService.userExam.contestInfoId === 36;
    });
    var passedText = computed(function () {
      if (userExam.value) {
        var passDesc = userExam.value.passDesc;
        var passed = userExam.value.passed;
        return passDesc ? passDesc : passed === 1 ? '未晋级' : passed === 2 ? '已晋级' : passed === 3 ? '晋级已撤销' : '--';
      }
    });
    var awardedText = computed(function () {
      if (userExam.value) {
        var awardDesc = userExam.value.awardDesc;
        var awarded = userExam.value.awarded;
        return awardDesc ? awardDesc : awarded === 1 ? '未获奖' : awarded === 2 ? "".concat(userExam.value.awardName) : awarded === 3 ? '获奖已撤销' : '--';
      }
    });
    var costTimeText = computed(function () {
      if (userExam.value) {
        if (userExam.value.costTime === null) {
          return '--';
        } else {
          return formatTime(userExam.value.costTime);
        }
      }
    });
    var showUserCertificate = reactive({
      visible: false
    });
    var getPlantTextString = function (type) {
      userExamService.getPlainText(userExam.value.userId, userExam.value.contestInfoId, type);
    };
    var goToExamAnswer = function () {
      var _a, _b;
      router.push({
        name: 'Examination',
        params: {
          id: (_a = userExam.value) === null || _a === void 0 ? void 0 : _a.userExamId,
          answerId: (_b = userExam.value) === null || _b === void 0 ? void 0 : _b.answerPaperId
        }
      });
    };
    var changeInfo = function () {
      router.push({
        name: 'ItemApply',
        params: {
          id: userExam.value.contestInfoId
        },
        query: {
          userExamId: id
        }
      });
    };
    var isExternalContest = computed(function () {
      var _a;
      return Boolean((_a = route.meta) === null || _a === void 0 ? void 0 : _a.isExternalContest);
    });
    var isNocFlag = computed(function () {
      if (isExternalContest.value) {
        return true;
      }
      return route.query.platform ? ContestPlatformVals.includes(route.query.platform) : false;
    });
    var myCompetionRoute = computed(function () {
      var _a;
      if (isExternalContest.value) {
        return {
          name: (_a = route.meta) === null || _a === void 0 ? void 0 : _a.entryUrlName,
          query: route.query
        };
      }
      return {
        path: '/user',
        query: route.query
      };
    });
    var canShowEidtBtn = computed(function () {
      var _a, _b, _c, _d, _e;
      var allowEditInfo = (_a = userExam.value) === null || _a === void 0 ? void 0 : _a.allowEditInfo;
      // 有品牌仅支持 非NOC 未开始考试的用户编辑信息
      if (SHOW_BRAND && ((_b = userExam.value) === null || _b === void 0 ? void 0 : _b.activityTypeDesc) !== 'NOC' && allowEditInfo) {
        return !((_c = userExam.value) === null || _c === void 0 ? void 0 : _c.currentExamStatus);
      }
      // 无品牌仅支持 未开始考试的用户编辑信息 无品牌仅支持区域活动修改
      if (!SHOW_BRAND && allowEditInfo && ((_d = userExam.value) === null || _d === void 0 ? void 0 : _d.activityTypeDesc) === '区域活动') {
        return !((_e = userExam.value) === null || _e === void 0 ? void 0 : _e.currentExamStatus);
      }
      return false;
    });
    return {
      userService: userService,
      SHOW_BRAND: SHOW_BRAND,
      userExamService: userExamService,
      userExam: userExam,
      passedText: passedText,
      awardedText: awardedText,
      costTimeText: costTimeText,
      CARD_TYPE: CARD_TYPE,
      SEX: SEX,
      GRADE: GRADE,
      CERTIFICATE_GET_METHODS: CERTIFICATE_GET_METHODS,
      showUserCertificate: showUserCertificate,
      getPlantTextString: getPlantTextString,
      value2label: value2label,
      formatDateToSecond: formatDateToSecond,
      goToExamAnswer: goToExamAnswer,
      changeInfo: changeInfo,
      hideGetCertification: hideGetCertification,
      isNocFlag: isNocFlag,
      route: route,
      myCompetionRoute: myCompetionRoute,
      canShowEidtBtn: canShowEidtBtn,
      HetaoDefaultAvatar: HetaoDefaultAvatar
    };
  }
});